var map = {
	"./GettyImages-1061685670_crop.jpg": 581,
	"./Moringa-collecting---Mike-goldwater-Alamy.jpg": 582,
	"./a-staple-food-withstand-disaster.jpg": 583,
	"./ageing-crisis.jpg": 584,
	"./crucial-ingredient.jpg": 585,
	"./greenRev_desktop.jpg": 586,
	"./greenRev_mobile.png": 587,
	"./greenRev_tablet.png": 588,
	"./growing-new-farmers.jpg": 589,
	"./how-to-cut-your-foods-carbon-footprint.jpg": 590,
	"./it-never-rains.jpg": 591,
	"./seeds-of-life.jpg": 592,
	"./the-farms-being-run-from-space.jpg": 593,
	"./the-hidden-hunger-affectiong-billions.jpg": 594,
	"./the-promised-land.jpg": 595,
	"./the-race-to-improve-food-security.jpg": 596,
	"./the-robots-putting-food-on-the-table.jpg": 597,
	"./the-wasteful-fate-of-a-third-of-food.jpg": 598,
	"./urban-farming.jpg": 599,
	"./vertical_farm.jpg": 600,
	"./why-soil-is-dissappearing-from-our-farms.jpg": 601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 580;